import { TFormField, FormFieldType } from '@models/forms';
import { QuoteStatus } from '@models/quotes';

export function getFormFields({ currentStatusId }: { currentStatusId: string }): {
  [fieldName: string]: TFormField;
} {
  const fields: { [fieldName: string]: TFormField } = {
    effectiveOn: {
      gridWidth: { xs: 12, sm: 6 },
      name: 'effectiveOn',
      label: 'New Policy Effective Date',
      placeholder: 'Effective Date',
      fieldType: FormFieldType.DatePickerField,
      disabled: false,
      required: false,
      defaultValue: new Date(),
    },
    reason: {
      gridWidth: { xs: 12, sm: 12, md: 12 },
      name: 'reason',
      label: 'Reason for Reactivation',
      fieldType: FormFieldType.TextField,
      required: true,
      fieldConfig: {
        textField: {
          multiline: true,
        },
      },
    },
  };

  // only show if rejected status
  if (currentStatusId === QuoteStatus.Rejected.name) {
    fields.bypassBOR = {
      gridWidth: { xs: 12, sm: 12, md: 12 },
      name: 'bypassBOR',
      label: 'Bypass BOR',
      fieldType: FormFieldType.CheckboxField,
      required: false,
    };
  }

  return fields;
}
